import { Badge } from '@art-of-hospitality-solutions-llc/ui-kit/components/badge';
import { Star } from 'lucide-react';
import { cn } from '@Utils/cn';

export interface GuestQuickDetailsProps {
  fullName: string;
  totalSpend: string;
  isClubMember?: boolean;
  className?: string;
}

export function GuestQuickDetails({
  fullName,
  totalSpend,
  isClubMember = false,
  className,
}: GuestQuickDetailsProps) {
  return (
    <div className={cn('flex flex-col items-start gap-1.5', className)}>
      <p className="w-[130px] truncate text-base leading-none font-bold text-aoh-ink dark:font-semibold dark:text-white">
        {fullName}
      </p>
      <div className="flex items-start gap-1 text-sm leading-5 font-normal text-aoh-muted dark:text-zinc-400">
        <span>{totalSpend}</span>
        <span>total spend</span>
      </div>
      {isClubMember && (
        <Badge
          variant="secondary"
          className="flex items-center justify-center gap-1 rounded-full border-0 bg-aoh-gold px-2 py-0.5 text-xs font-semibold text-aoh-gold-ink dark:rounded-md dark:bg-[#c0a364] dark:text-primary-foreground"
        >
          <Star className="size-3" />
          Club Member
        </Badge>
      )}
    </div>
  );
}
